// Renders a roman numeral string, wrapping [bracketed] vinculum groups with a
// continuous CSS overline spanning the whole group (correct vinculum notation).
// Plain characters outside brackets are rendered as-is.

export default function RomanDisplay({
  roman,
  style,
}: {
  roman: string
  style?: React.CSSProperties
}) {
  const parts: React.ReactNode[] = []
  // Create regex fresh each render so lastIndex state is never shared
  const re = /(\[[^\]]+\])|([^[]+)/g
  let match: RegExpExecArray | null
  let i = 0
  while ((match = re.exec(roman)) !== null) {
    if (match[1]) {
      parts.push(
        <span key={i++} style={vincStyle}>
          {match[1].slice(1, -1)}
        </span>
      )
    } else if (match[2]) {
      parts.push(<span key={i++}>{match[2]}</span>)
    }
  }
  return <span style={style}>{parts}</span>
}

const vincStyle: React.CSSProperties = {
  display:       'inline-block',
  borderTop:     '0.1em solid currentColor',
  paddingTop:    '0.05em',
  letterSpacing: 'inherit',
}
